<template>
  <main class="page-apis page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <div class="top-btns">
        <el-button @click="$_modify(-1)" class="btn__add">新增运营商</el-button>
      </div>
      <el-form :inline="true" class="filter-form">
        <el-form-item label="运营商名称:">
          <el-input
            v-model="filter.platformName"
            style="width: 110px;"
          ></el-input>
        </el-form-item>

        <el-form-item label="系统运营商ID:">
          <el-input
            v-model="filter.id"
            style="width: 110px;"
            maxlength="9"
          ></el-input>
        </el-form-item>

        <el-form-item label="共享运营商编码:">
          <el-input
            v-model="filter.sscPlatformMerchantId"
            style="width: 110px;"
          ></el-input>
        </el-form-item>

        <el-form-item label="共享运营商key:">
          <el-input
            v-model="filter.sscPlatformKey"
            style="width: 110px;"
          ></el-input>
        </el-form-item>

        <el-form-item label="运营商key:">
          <el-input
            v-model="filter.platformKey"
            style="width: 110px;"
          ></el-input>
        </el-form-item>

        <el-form-item label="组织类型:">
          <el-select
            v-model="filter.orgType"
            filterable
            style="width: 110px;"
            placeholder="请选择状态"
          >
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="默认组织" :value="0"></el-option>
            <el-option label="自定义组织" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$reset" class="reset__btn">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        v-loading="isLoading"
        stripe
        border
        tooltip-effect="dark"
      >
        <el-table-column label="操作" width="400" :resizable="false">
          <template slot-scope="scope">
            <!-- <router-link style="margin-right: 10px;" :to="{ path: '/merchants/organization', query:{id: scope.row.platformKey}}"><el-button size="mini" class="edit__btn">组织架构管理</el-button></router-link> -->
            <el-button
              size="mini"
              class="edit__btn"
              @click="$_goOrg(scope.row)"
              style="margin-right: 10px;"
              >组织架构管理</el-button
            >
            <cd-switch
              v-model="scope.row.status"
              style="margin-right: 10px;"
              @input="$_switch(scope.$index, scope.row)"
              :true-value="1"
              :false-value="2"
            >
              <span slot="open">启用</span>
              <span slot="close">停用</span>
            </cd-switch>
            <el-button
              size="mini"
              class="edit__btn"
              @click="$_modify(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              class="delete__btn"
              @click="$_delete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>

        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          v-else
        >
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row"></component>
          </template>
        </el-table-column>

        <div slot="empty">没有数据</div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getPlatformList"
      ></cd-pagination>
    </div>

    <modal-modify
      v-if="modal.show"
      :title="modal.title"
      :formType="modal.type"
      :modalData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></modal-modify>

    <router-view></router-view>
  </main>
</template>

<script>
import * as Utils from "@/plugins/utils";
import resize from "@/mixins/resize";
import modalModify from "./modal-modify";

const columns = [
  { key: "platformName", label: "运营商", width: 160 },
  { key: "id", label: "系统运营商ID", width: 160 },
  { key: "sscPlatformMerchantId", label: "共享运营商编码", width: 160 },
  { key: "sscPlatformKey", label: "共享运营商key", width: 160 },
  { key: "platformKey", label: "运营商key", width: 160 },
  {
    key: "orgType",
    label: "组织类型",
    width: 160,
    component: "orgTypeTmpl",
    align: "center",
  },
  {
    key: "platformType",
    label: "运营商类型",
    width: 160,
    component: "platformTypeTmpl",
  },
  { key: "creator", label: "创建人", width: 120 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "operator", label: "最后编辑人", width: 120 },
  { key: "updateTime", label: "最后编辑时间", width: 160 },
  { key: "memo", label: "备注" },
];
export default {
  name: "merchants-platforms-list",
  mixins: [resize],
  data() {
    return {
      filter: {
        platformKey: "",
        id: "",
        platformName: "",
        sscPlatformMerchantId: "",
        sscPlatformKey: "",
        orgType: -1,
      },
      tableHeight: null,
      isLoading: false,
      dataList: [],
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0,
      },
      modal: {
        show: false,
        type: "add",
        template: "",
        data: {},
      },
    };
  },

  methods: {
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      let reg = /[^\d.]/g;
      if (this.filter.id && new RegExp(reg).test(this.filter.id)) {
        $MessageBox.alert({
          content: `
            <div>系统运营id需填数字！</div>
          `,
        });
      } else {
        this.$_getPlatformList();
      }
    },
    // 重置
    $reset() {
      this.filter.id = "";
      this.filter.platformKey = "";
      this.filter.platformName = "";
      this.filter.sscPlatformMerchantId = "";
      this.filter.sscPlatformKey = "";
      this.filter.orgType = -1;
      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getPlatformList();
    },
    // 查询运营商列表
    $_getPlatformList() {
      this.isLoading = true;
      this.$refs.tableList.clearSort();
      const postData = {
        platformKey: this.filter.platformKey,
        id: this.filter.id || 0,
        platformName: this.filter.platformName,
        sscPlatformMerchantId: this.filter.sscPlatformMerchantId,
        sscPlatformKey: this.filter.sscPlatformKey,
        orgType: this.filter.orgType,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize,
      };
      this.$service.post("pagingPlatform", postData).then((result) => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    // 新增/编辑运营商成功回调
    $_callback() {
      this.$_close();
      this.$_getPlatformList();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    },
    // 新增/编辑
    $_modify($index, row) {
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "新增运营商";
      if ($index !== -1) {
        this.modal.type = "edit";
        this.modal.data = JSON.parse(JSON.stringify(row));
        this.modal.title = "编辑运营商";
      }
      this.modal.template = "modify";
      this.modal.show = true;
    },

    //组织架构管理
    $_goOrg(item) {
      this.$emit("changeTab", {
        name: "orgComponent",
        contData: JSON.parse(JSON.stringify(item)),
      });
    },

    // 启用/停用
    $_switch($index, row) {
      const self = this;
      const callback = (content) => {
        $MessageBox.alert({
          content,
          onOk() {
            self.$_getPlatformList();
          },
        });
      };
      let pidList = [row.id];
      if (row.status === 1) {
        // 停用切换成启用
        self.$service
          .post("updatePlatformStatus", {
            pidList,
            status: 1,
          })
          .then((result) => {
            if (result.$.checkResult(result, true)) {
              callback(result.msg);
            } else {
              self.dataList[$index].status = 2;
            }
          });
      } else if (row.status === 2) {
        // 启用切换成停用
        $MessageBox.confirm({
          content: `
            <div>是否停用当前运营商?</div>
            <div>停用后将会影响运营商下面所有接口的正常使用, 请谨慎!</div>
          `,
          onOk() {
            self.$service
              .post("updatePlatformStatus", {
                pidList,
                status: 2,
              })
              .then((result) => {
                if (result.$.checkResult(result, true)) {
                  callback(result.msg);
                } else {
                  self.dataList[$index].status = 1;
                }
              });
          },
          onCancel() {
            self.dataList[$index].status = 1;
          },
        });
      }
    },

    // 删除
    $_delete(row) {
      const self = this;
      const callback = (content) => {
        $MessageBox.alert({
          content,
          onOk() {
            self.$_getPlatformList();
          },
        });
      };
      let pidList = [row.id];
      const content = "是否确认删除运营商，结果会删除所有系统的同一个运营商"
      $MessageBox.confirm({
        countDown: 5, //倒计时5秒
        content,
        onOk() {
          self.$service
            .post("updatePlatformStatus", {
              pidList,
              status: 3,
            })
            .then((result) => {
              if (result.$.checkResult(result, true)) {
                callback(result.msg);
              }
            });
        },
      });
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getPlatformList();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getPlatformList();
    },
  },

  components: {
    modalModify,
    orgTypeTmpl: {
      template: `
        <span v-if="row.orgType===0">默认组织</span>
        <span v-else>自定义组织</span>
      `,
      props: { row: { type: Object, required: true } },
    },
    platformTypeTmpl: {
      template: `
        <span v-if="row.platformType===1">餐饮</span>
        <span v-else-if="row.platformType===2">零售</span>
        <span v-else></span>
      `,
      props: { row: { type: Object, required: true } },
    },
  },

  mounted() {
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    this.$_getPlatformList();
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
  margin: 20px 16px 24px 20px;
  border: 1px solid #eee;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .top-btns {
    min-height: 50px;
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
  // margin-bottom: 44px;
}
</style>
